import { render, staticRenderFns } from "./CalendarRanges.vue?vue&type=template&id=1132cff0&"
import script from "./CalendarRanges.vue?vue&type=script&lang=js&"
export * from "./CalendarRanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports